var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusInvited = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#02607F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.5 12.274 6.825 4.32V7.78zM2.078 7.78v8.814l6.826-4.32zM21.058 5.218H3.346c-.634 0-1.138.475-1.224 1.08l10.08 6.638 10.08-6.638c-.101-.605-.59-1.08-1.224-1.08zM14.333 13.037l-1.786 1.18c-.1.073-.23.101-.345.101a.604.604 0 0 1-.346-.1l-1.786-1.181-7.934 5.025c.1.605.59 1.066 1.224 1.066h17.712c.634 0 1.123-.46 1.224-1.066l-7.963-5.025z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusInvited);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-status-invited.9890736304470e6c1a4752ea1ac5f0b4.svg";